import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { BannerPcImage, BannerSpImage, MultiCreatorLpLink } from '../../molecules/multi_creator/MultiCreatorBanner';
import './topPagemultiCreatorBanner.module.scss';

export const TopPageMultiCreatorBanner = observer(({ className }) => {
    const { isSp } = useViewportState();
    return isSp ? <TopPageMultiCreatorBannerSp /> : <TopPageMultiCreatorBannerPc className={className} />;
});

const TopPageBannerDescription = () => (
    <>
        <div styleName="header">さらに本気で転職を目指すなら</div>
        <div styleName="description">
            SHElikes MULTI CREATOR COURSE Designerは、<br />
            未経験でクリエイターへのキャリアチェンジを目指す女性のための<span styleName="red">
                短期集中型の特別コース
            </span>です。
        </div>
    </>
);

export const TopPageMultiCreatorBannerSp = () => {
    return (
        <div styleName="multi-creator-banner-wrapper">
            <div styleName="multi-creator-banner-content">
                <div styleName="content">
                    <BannerPcImage />
                    <TopPageBannerDescription />
                    <MultiCreatorLpLink text="特設ページはこちら" />
                </div>
            </div>
        </div>
    );
};

export const TopPageMultiCreatorBannerPc = ({ className }) => {
    return (
        <div styleName={classNames('multi-creator-banner-wrapper')} className={className}>
            <div styleName="multi-creator-banner-content">
                <BannerSpImage />
                <div styleName="content">
                    <TopPageBannerDescription />
                    <MultiCreatorLpLink text="特設ページはこちら" />
                </div>
            </div>
        </div>
    );
};
